<template>
  <div>
    <section-header ref="MES_TRANSACTIONS"
                    :dialog="false"
                    :isExtended="extended"
                    :ressource="ressource">
    </section-header>

    <v-data-table :headers="listHeader"
                  no-data-text="Aucune donnée"
                  :items="items"
                  :items-per-page="-1"
                  class="white iterate-list"
                  disable-pagination
                  fixed-header
                  hide-default-footer
                  mobile-breakpoint="100"
                  style="border-radius:12px;"
                  @click:row="validTransaction">
      <template v-slot:[`item.statut`]="{ item }">
        {{ getStatut(item.statut) }}
      </template>
    </v-data-table>
  </div>
</template>

<script lang="ts">
import { GenSection, RessourceGenSection } from '@/generated/ressources/generatedRessources';
import Transaction, { TransactionStatuts } from '@/generated/classes/Transaction';
import { storeTransaction } from '@/generated/stores';
import SectionHeader from '@/framework/base/components/SectionHeader.vue';
import { Alerts } from '@/framework/base/helpers/Alerts';
import { defineComponent } from "vue";

export default defineComponent({
  components: {
    SectionHeader
  },
  props: {
    hideTitle: {
      type: Boolean
    },
    extended: {
      type: Boolean
    }
  },
  data() {
    return {
      listHeader: [
        { text: 'Date', value: 'date', sortable: true },
        { text: 'Montant', value: 'montant', sortable: true },
        { text: 'Réglé par', value: 'paymentMeans', sortable: true },
        { text: 'Factures', value: 'factures', sortable: true },
        { text: 'Statut', value: 'statut', sortable: true }
      ]
    };
  },
  computed: {
    items(): Transaction[] {
      return storeTransaction.listTransaction.filter(a => a.statut == TransactionStatuts.EMITTED);
    },
    ressource() {
      return RessourceGenSection(GenSection.POINTAGES);
    }
  },
  methods: {
    getStatut(statut: TransactionStatuts): string {
      if (statut == TransactionStatuts.WAITED) {
        return 'Non réglé';
      } else if (statut == TransactionStatuts.EMITTED) {
        return 'Non pointé';
      } else if (statut == TransactionStatuts.PAYED) {
        return 'Pointé';
      } else {
        return 'Invalide';
      }
    },
    validTransaction(transaction: Transaction) {
      Alerts.debug('Dialog pointage');
    }
  }
})

</script>
